<div class="container bg-white px-3 py-2 w-80 rounded-sm">
  <!-- Show message if training is not found -->
  <div *ngIf="showTrainingNotFound" class="text-center my-3">
    <h5 class="text-dark mb-0">The training is either not available or you do not have access to it..</h5>
  </div>

  <!-- Show quiz table only if training exists -->
  <ng-container *ngIf="!showTrainingNotFound">
    <div class="mt-2">
      <h2 class="text-custom mb-0">
        Trainee Quiz Report:
        {{
          currentStage === "pre"
            ? "Pre-Course"
            : currentStage === "post"
            ? "Post-Course"
            : "PLJ2-Course"
        }}
      </h2>

      <p class="text-custom mb-0 mt-1">
        Please verify all participant responses for the training "<strong>{{
          trainingTitle
        }}</strong
        >"
        <span *ngIf="trainingCode">({{ trainingCode }})</span>
        by choosing the V dropdown. Also, add comments to each response as
        appropriate.
      </p>
    </div>

    <!-- Main review table -->
    <div class="mt-n3">
      <table class="m-0">
        <thead>
          <tr>
            <th scope="col" class="text-custom py-1 px-2 heading-cell">
              Participants
            </th>
            <th
              *ngFor="let topic of quizTopics"
              scope="col"
              class="px-6 py-1 vertical-text-header align-bottom"
            >
              <span class="vertical-text">{{ topic.fullQuestion }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let trainee of quizData.data; let i = index">
            <td class="text-dark py-0 px-2 left-cell">
              {{ trainee.trainee_name }}
            </td>
            <td *ngFor="let topic of quizTopics; let j = index">
              <div class="d-flex align-items-center gap-1 score-row">
                <span
                  class="shared-score-size"
                  [ngClass]="
                    getClassForTraineeAndTopic(trainee.trainee_id, topic.key)
                  "
                  [title]="
                    getLevelForTraineeAndTopic(trainee.trainee_id, topic.key)
                  "
                >
                </span>

                <!-- verify dropdown -->
                <app-training-verify-dropdown
                  [traineeId]="trainee.trainee_id"
                  [topicKey]="topic.key"
                  [options]="getAnswerOptions(trainee, topic.key)"
                  [currentScore]="
                    supervisorScores.get(trainee.trainee_id + '-' + topic.key)
                      ?.quiz_question_answer_id
                  "
                  [isSaving]="
                    isSavingForTraineeAndTopic(trainee.trainee_id, topic.key)
                  "
                  [buttonClass]="
                    getColorClassByAnswerId(trainee.trainee_id, topic.key)
                  "
                  [disabled]="isSubmitted"
                  (scoreChange)="
                    onSupervisorScoreChange(
                      trainee.trainee_id,
                      topic.key,
                      $event
                    )
                  "
                >
                </app-training-verify-dropdown>

                <!-- comment icon -->
                <fa-icon
                  [icon]="
                    hasComment(trainee.trainee_id, topic.key)
                      ? faCommentSolid
                      : faCommentRegular
                  "
                  class="fa-sm comment-btn text-muted"
                  role="button"
                  (click)="openCommentPopup(trainee.trainee_id, topic.key)"
                >
                </fa-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="submit-container">
      <button 
        *ngIf="!isSubmitted"
        class="submit-btn" 
        (click)="submitTrainingVerify()">
        Submit Verifications
      </button>
    </div>
  </ng-container>
</div>
